module.exports = __webpack_public_path__ + "img/reward.0cf1f07a.svg";